export function addCopyAndPasteEventToElement (element) {
	element.addEventListener("keydown", e => {
		if (e.key === "c" && e.ctrlKey) {
			element.dispatchEvent(new CustomEvent("copy", { bubbles: true }))
		}
		if (e.key === "v" && e.ctrlKey) {
			element.dispatchEvent(new CustomEvent("paste", { bubbles: true }))
		}
	})
}
